module.exports = __webpack_public_path__ + "img/face-id.svg";